export default {
    namespaced: true,
    state: {
        profileUpdateRequired: false,
        workflowFilesUpdateRequired: false,
        maintenanceModeUpdateRequired: false,
        websocketUpdateRequired: false,
    },
    mutations: {
        setProfilUpdateRequired(state, profileUpdateRequired) {
            state.profileUpdateRequired = profileUpdateRequired;
        },
        setWorkflowFilesUpdateRequired(state, workflowFilesUpdateRequired) {
            state.workflowFilesUpdateRequired = workflowFilesUpdateRequired;
        },
        setMaintenanceModeUpdateRequired(state, maintenanceModeUpdateRequired) {
            state.maintenanceModeUpdateRequired = maintenanceModeUpdateRequired;
        },
        setWebsocketUpdateRequired(state, websocketUpdateRequired) {
            state.websocketUpdateRequired = websocketUpdateRequired;
        },
        
    },
    actions: {
        resetProfileUpdateRequired({ commit }) {
            commit('setProfilUpdateRequired', false);
        },
        resetWorkflowFilesUpdateRequired({ commit }) {
            commit('setWorkflowFilesUpdateRequired', false);
        },
        resetMaintenanceModeUpdateRequired({ commit }) {
            commit('setMaintenanceModeUpdateRequired', false);
        },
        resetWebsocketUpdateRequired({ commit }) {
            commit('setWebsocketUpdateRequired', false);
        },
    },
    getters: {
        getProfileUpdateRequired: (state) => state.profileUpdateRequired,
        getWorkflowFilesUpdateRequired: (state) => state.workflowFilesUpdateRequired,
        getMaintenanceModeUpdateRequired: (state) => state.maintenanceModeUpdateRequired,
        getWebsocketUpdateRequired: (state) => state.websocketUpdateRequired,
    },
}
